const {needFor} = require('./rules.js');

const urlQueryString = new URLSearchParams(window.location.search);

function parseQueryParamAsInt(param) {
  return parseInt(urlQueryString.get(param), 10);
}

module.exports.parseLevelQueryString = function() {
  const waves = parseQueryParamAsInt('waves') || 1;
  const ducks = parseQueryParamAsInt('ducks') || 1;
  return {
    id: -1,
    waves,
    ducks,
    speed: parseQueryParamAsInt('speed') || 8,
    bullets: parseQueryParamAsInt('bullets') || 100,
    clock: parseQueryParamAsInt('time') || 30,
    need: needFor(waves * ducks)
  };
};

// Only these mean "custom level". Checking for any query string at all would
// make unrelated parameters -- ?dog=kevin, a share link's tracking tag -- build
// a generated level instead of playing the real game.
const LEVEL_PARAMS = ['waves', 'ducks', 'points', 'speed', 'bullets', 'radius', 'time'];

module.exports.urlContainsLevelData = function() {
  return LEVEL_PARAMS.some((param) => urlQueryString.has(param));
};